import React, { useEffect, useState, FC } from "react";

import { useStore } from "react-stores";
import { globalStore } from "../../globalStore";
import { useAnchorWallet, useWallet } from "@solana/wallet-adapter-react";
import { MallocSPLBuildActionMap, splConstants } from "@malloc-protocol/spl";
import { saveStringToFile } from "../../utils/files";

import { TokenListProvider, TokenInfo, ENV } from "@solana/spl-token-registry";
import RaydiumSwapNodeInfo from "./raydium-swap";
import { Box } from "@mui/system";
import {
  UpdateActionInputFn,
  UpdateActionNextActionsFn,
  UpdateSourceFn,
} from "../../interfaces";
import {
  NonSpecificAction,
  NonSpecificActionFilled,
  NonSpecificConstruction,
  NonSpecificConstructionOpts,
} from "@malloc-protocol/sdk";
import TransferNodeInfo from "./transfer";
import { SOURCE_NAME } from "../../config/constants";
import { buildConstructionAndFill, deleteAction } from "../../utils/malloc";
import InputGroup from "../inputs/input-slider";
import SourceNodeInfo from "./source-node-info";
import RaydiumLPDepositInfo from "./raydium-lp-deposit";

const renderInput = (
  actionType: string,
  updateInput: UpdateActionInputFn,
  updateSource: UpdateSourceFn,
  input: any,
  inputMints: NonSpecificConstruction["source"]["mints"],
  action?: NonSpecificActionFilled
) => {
  switch (actionType) {
    case SOURCE_NAME:
      return (
        <SourceNodeInfo updateSource={updateSource} inputMints={inputMints} />
      );
    case splConstants.BUILD_ACTION_UIDS.TRANSFER:
      return <TransferNodeInfo updateInput={updateInput} input={input} />;
    case splConstants.BUILD_ACTION_UIDS.RAYDIUM_LP_STAKE:
      return null;
    case splConstants.BUILD_ACTION_UIDS.RAYDIUM_LP_DEPOSIT:
      return <RaydiumLPDepositInfo updateInput={updateInput} input={input} />;
    case splConstants.BUILD_ACTION_UIDS.RAYDIUM_SWAP:
      const DEFAULT_IN_MINT_IDX_TO_CHECK = 0;
      return (
        <RaydiumSwapNodeInfo
          updateInput={updateInput}
          input={input}
          inputMint={action?.inMints?.[DEFAULT_IN_MINT_IDX_TO_CHECK]}
        />
      );
    case splConstants.BUILD_ACTION_UIDS.SOLEND_LP_DEPOSIT:
      return null;
    // SOURCE
    default:
      return null;
  }
};

const NodeInfo: FC<{}> = () => {
  // const wallet = useAnchorWallet();
  const state = useStore(globalStore);

  const selectedAction = state.context.nodes[state.context.selectedNodeId];

  if (!selectedAction) return <></>;

  const isSource = selectedAction.isSource;
  let expectedNumberOfOutMints: number | undefined;
  let NSPConstructionNode: NonSpecificActionFilled | undefined,
    actionType: string,
    actionInputs: any,
    nextActions: any;
  // @ts-ignore

  if (isSource) {
    actionType = SOURCE_NAME;
    actionInputs = null;
    nextActions = state.construction.source.nextActions;
  } else {
    NSPConstructionNode = (
      state.construction.actionDatas[selectedAction.id] as any
    ).action as NonSpecificActionFilled;
    actionType = NSPConstructionNode.actionTypeUID;
    actionInputs = NSPConstructionNode.inputs;
    nextActions = NSPConstructionNode.nextActions;
    expectedNumberOfOutMints =
      MallocSPLBuildActionMap[actionType].expectedNumberOutMints;
  }

  const updateSource: UpdateSourceFn = (newMints) => {
    state.construction.source.mints = newMints;
    globalStore.setState({
      ...state,
    });
  };

  const updateInput = (inp: any) => {
    //@ts-ignore
    (
      (state.construction.actionDatas[selectedAction.id] as any)
        .action as NonSpecificAction
    ).inputs = inp;

    globalStore.setState({
      ...state,
    });
  };
  const InputComponent = isSource
    ? renderInput(
        actionType,
        updateInput,
        updateSource,
        actionInputs,
        state.construction.source.mints
      )
    : renderInput(
        actionType,
        updateInput,
        updateSource,
        actionInputs,
        state.construction.source.mints,
        NSPConstructionNode
      );

  const updateNextActions: UpdateActionNextActionsFn = (nextActions) => {
    if (selectedAction.isSource) {
      state.construction.source.nextActions = nextActions;
    } else {
      (
        (state.construction.actionDatas[selectedAction.id] as any)
          .action as NonSpecificAction
      ).nextActions[state.context.selectedOutMintIndex] = nextActions;
    }

    globalStore.setState({
      ...state,
    });
  };

  const getNextActionGroup = () => {
    return selectedAction.isSource
      ? state.construction.source.nextActions
      : (
          (state.construction.actionDatas[selectedAction.id] as any)
            .action as NonSpecificAction
        ).nextActions[state.context.selectedOutMintIndex];
  };

  return (
    <div className="card">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <input
          value={selectedAction.id}
          type="text"
          className="inputField"
          style={{ width: "90%" }}
          // TODO: rename node id's
          // current issue => state.context datastructure => requires alot of search
          // @shiva revisit this
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            // const newKey = event.target.value;
            // if (newKey === "") return;
            // if (!state.context.nodes.hasOwnProperty(newKey)) {
            //   state.context.nodes[newKey] = JSON.parse(
            //     JSON.stringify(selectedAction)
            //   );
            //   delete state.context.nodes[selectedAction.id];
            //   state.construction.actionDatas[newKey] = JSON.parse(
            //     JSON.stringify(
            //       state.construction.actionDatas[selectedAction.id]
            //     )
            //   );
            //   delete state.construction.actionDatas[selectedAction.id];
            //   selectedAction.id = newKey;
            //   globalStore.setState({
            //     ...state,
            //   });
            // }
          }}
        ></input>
        {!selectedAction.isSource && (
          <button
            className="delete"
            onClick={() => {
              deleteAction(selectedAction.id);
            }}
          >
            x
          </button>
        )}
      </div>

      <Box sx={{ m: 2 }}>
        <h5>Input</h5>
      </Box>
      {InputComponent && InputComponent}

      {/* {(expectedNumberOfOutMints === undefined ||
        expectedNumberOfOutMints > 0) && ( */}
      <div>
        {(isSource || (nextActions && nextActions.length >= 1)) && (
          <>
            <h5>Next Actions</h5>

            {isSource && (
              <InputGroup
                updateNextActions={updateNextActions}
                nextActions={getNextActionGroup()}
              />
            )}
            {!isSource &&
              nextActions.map((mintActions: any, index: number) => {
                return (
                  <InputGroup
                    updateNextActions={updateNextActions}
                    nextActions={getNextActionGroup()}
                  />
                );
              })}
          </>
        )}
      </div>
    </div>
  );
};

export default NodeInfo;
